import { useRef, useState } from 'react';
import cn from 'classnames';
import { IMenuItem } from 'models/IMenuItem';
import { useTouchStartNavigate } from 'components/MainMenu/useTouchStartNavigate';
import { NotifyLink } from 'components/Shared/NotifyLink';
import { Category } from './category';
import styles from './section.scss';
import { getQaDataAttr } from '@bygghemmait/utilities';
import { useDispatch } from 'react-redux';
import { GtmHeaderNavClick } from 'store/googleTagManager/actions';

interface SectionProps {
  section: IMenuItem;
  openMenu: () => void;
  closeMenu: () => void;
  openId?: string;
  menuOpen: boolean;
  isLoading: boolean;
  hideDropdown?: boolean;
}

export const SectionLink = ({
  section,
  openMenu,
  closeMenu,
  openId,
  menuOpen,
  isLoading,
  hideDropdown
}: SectionProps) => {
  const isOpen = menuOpen && section.id === openId;
  const { url, ticket, id, subCategories, title } = section;
  const reduxDispatch = useDispatch();
  const [, setRef] = useTouchStartNavigate<HTMLAnchorElement | undefined>(useState(), {
    isLoading,
    isOpen,
    closeMenu,
    openMenu
  });

  const handleOnClick = () => {
    reduxDispatch(GtmHeaderNavClick(url));
  };

  return (
    <div className={styles.sectionWrapper} onMouseOver={openMenu} onMouseOut={closeMenu}>
      <NotifyLink
        className={cn(styles.section, {
          [styles.open]: isOpen
        })}
        onClick={handleOnClick}
        url={url}
        ticket={ticket}
        setRef={setRef}
        {...getQaDataAttr(`link-nav-${id}`)}
      >
        <span>{title}</span>
      </NotifyLink>

      {isOpen && !hideDropdown && <Category subCategories={subCategories} />}
    </div>
  );
};

interface FakeSectionProps extends Omit<SectionProps, 'section'> {
  title: string;
  sectionId: string;
}
export const Section = ({
  title,
  sectionId,
  openMenu,
  closeMenu,
  openId,
  menuOpen
}: FakeSectionProps) => {
  const isOpen = menuOpen && sectionId === openId;
  const spanRef = useRef<HTMLSpanElement | null>(null);

  return (
    <div className={styles.sectionWrapper} onMouseOver={openMenu} onMouseOut={closeMenu}>
      <span
        className={cn(styles.section, {
          [styles.open]: isOpen
        })}
        ref={spanRef}
      >
        <span>{title}</span>
      </span>

      {isOpen && <Category />}
    </div>
  );
};
